<template>
  <b-form @submit.prevent="onSubmit">
    <b-form-group label="Title">
      <b-form-input
        v-model="learningOutcome.title"
        name="title"
        type="text"
        class="input__title"
        :disabled="disabled"
        :state="invalid ? $v.learningOutcome.title.required : null"
      ></b-form-input>

      <b-form-invalid-feedback id="title-feedback">
        <span v-if="!$v.learningOutcome.title.required">Title is required</span>
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group>
      <label for="description">
        <span class="mr-1">Description</span>
        <span class="text-muted">(Optional)</span>
      </label>

      <base-text-editor
        v-model="learningOutcome.description"
        name="description"
        class="input__description"
        :disabled="disabled"
      ></base-text-editor>
    </b-form-group>

    <div class="mb-5 d-flex form__footer border-top pt-2 mt-5">
      <b-button :disabled="disabled" type="submit" variant="success" class="mr-3 h-50 btn__submit">
        <b-spinner v-if="submitting" />
        <span v-else>{{ id ? 'Save' : 'Create' }}</span>
      </b-button>

      <b-button
        :disabled="disabled"
        variant="link"
        class="btn-link-dark mr-3 h-50 btn__cancel"
        @click="goBackToPreviousPage"
      >
        Cancel
      </b-button>
    </div>
  </b-form>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { LearningOutcome } from '../../models';
import BaseTextEditor from '@/components/base-components/BaseTextEditor';

export default {
  components: {
    BaseTextEditor
  },
  mixins: [validationMixin],

  props: {
    learningUnitId: {
      type: [String, Number],
      required: true
    },

    id: {
      type: [String, Number],
      default: null
    },

    formData: {
      type: Object,
      default: null
    },

    apiProvider: {
      type: Function,
      required: true
    },

    redirect: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      invalid: false,
      submitting: false,
      disabled: false,
      learningOutcome: new LearningOutcome({
        title: this.formData ? this.formData.title : '',
        description: this.formData ? this.formData.description : null
      }),
      editorOptions: {
        modules: {
          toolbar: [[{ list: 'ordered' }, { list: 'bullet' }], ['link']]
        },
        placeholder: ''
      }
    };
  },

  validations() {
    return {
      learningOutcome: {
        title: { required }
      }
    };
  },

  methods: {
    async onSubmit() {
      this.$v.$touch();

      this.invalid = false;

      if (this.$v.$invalid) {
        this.invalid = true;

        return this.$toast.error(
          `Cannot ${this.id ? 'update' : 'create'} learning outcome, please check error messages`
        );
      }

      let promise;

      try {
        this.disabled = true;
        this.submitting = true;

        await this.apiProvider({ ...this.learningOutcome });

        this.$toast.success(
          `The ultimate learning outcome was ${this.id ? 'updated' : 'created'} successfully`
        );

        this.$emit('submit', { ...this.learningOutcome });
      } catch (error) {
        console.log(error);

        this.disabled = false;

        this.$toast.error(`Cannot ${this.id ? 'update' : 'create'} an ultimate learning outcome`);
      } finally {
        this.submitting = false;
      }

      return promise;
    },

    goBackToPreviousPage() {
      this.$emit('back');

      if (this.redirect) {
        if (this.$route.query.previousPath) {
          const { previousPath } = this.$route.query;

          this.$router.push({ path: previousPath });
        } else {
          this.$router.go(-1);
        }
      }
    }
  }
};
</script>
